import { createContext, useContext } from "react";
import type { User, UserDetails } from "../../type";
import type {
  AuthResponseRegister,
  RegisterRequest,
  VerifyEmailRequest,
} from "../services/auth.type";

export type AuthContextType = {
  user: (User & UserDetails) | null;
  token: string | null;
  /** False until the stored session has been read (always false on the server). */
  isRestored: boolean;
  login: (
    login: string,
    password: string,
    rememberMe?: boolean
  ) => Promise<void>;
  register: (data: RegisterRequest) => Promise<AuthResponseRegister>;
  verifyEmail: (data: VerifyEmailRequest) => Promise<void>;
  googleAuth: (idToken: string) => Promise<void>;
  appleAuth: (idToken: string, rememberMe?: boolean) => Promise<void>;
  logout: () => void;
  refreshUser: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
